export default __webpack_public_path__ + "static/media/portfolio-madrid-2.d8e7f722.jpg";